import { useIntl } from 'react-intl';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { putRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';
import messages from 'src/pages/GatekeeperPage/messages';

import type { RequestSimplifiedData } from 'src/types/requestData';

type MarkAccountDeletedParams = {
  candidateUuid: string;
  reasonCode: string;
  comment?: string;
};

const markAccountDeleted = async ({
  candidateUuid,
  reasonCode,
  comment,
}: MarkAccountDeletedParams) => {
  await putRequest<RequestSimplifiedData>(
    API.PUT.markAccountDeleted(candidateUuid),
    {
      deletion_reason: {
        reason_code: reasonCode,
        comment,
      },
    },
  );
};

export const useMarkAccountDeleted = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: markAccountDeleted,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.userAccountDeleted), 1000);

      client.invalidateQueries({ queryKey: [QUERY_KEYS.USER_ACCOUNTS] });
    },
    onError: handleError,
  });
};
